const moment = require('moment');

/**
 * Helper function to show a button to open the time series in Graylog
 */
module.exports = function(H) {
	H.addEvent(H.Chart, 'load', function (e) {
		const chart = e.target;

		if (typeof chart.options.logUrl !== 'string') {
				return;
		}

		const btnOptions = this.options.chart.resetZoomButton;
		const theme = btnOptions.theme;
		const states = theme.states;
		const alignTo = btnOptions.relativeTo === 'chart' ? null : 'plotBox';

		function openLogs() {
			const zoomLevel = chart.axes[0].getExtremes();
			const minTime = encodeURIComponent(moment(zoomLevel.userMin).toISOString());
			const maxTime = encodeURIComponent(moment(zoomLevel.userMax).toISOString());

			window.open(chart.options.logUrl + "&from=" + minTime + "&to=" + maxTime);
		}

		const logBtn = this.renderer
			.button('Open in Graylog', null, null, openLogs, theme, states && states.hover)
			.addClass('highcharts-open-graylog')
			.attr({
				title: 'View the environment logs for the shown time period'
			})
			.add();

		// Reposition the box to ensure it doesn't hang off the viewport
		btnOptions.position.x -= logBtn.width;
		logBtn.align(btnOptions.position, false, alignTo);
	});
};